export const getLeadStateByPractitioner = (practitioner: any) => {
    if (practitioner?.data_source === "PRACTITIONER_ACCOUNT_VIEW") {
        if (practitioner?.stage === "PROSPECT" || practitioner?.stage === "CUSTOMER") {
            return "";
        }
        if (!practitioner?.stage || practitioner?.stage === "LEAD") {
            if (practitioner.status === "LEAD-INCOMPLETE") {
                return "Not in Netsuite: Incomplete Lead"
            }
            if (practitioner.status === "LEAD-READY2SUBMIT") {
                return "Not in Netsuite: Ready to Submit"
            }
            if (practitioner.status === "LEAD-AWAITING-NETSUITE") {
                return "Submitted to Netsuite: Awaiting Qualification Process."
            }
            if (practitioner.status === "New" || practitioner.status === "No Response" || practitioner.status === "Unqualified" || practitioner.status === "Sales Rep" || practitioner.status === "Established" || practitioner.status === "Lost (L)") {
                return ""
            }
            return "Not in Netsuite: Unknown status";
        }
    }
    if (practitioner?.data_source === "PRACTITIONER_DISTRIBUTOR_ACCOUNT_VIEW") {
        return "";
    }
    if (practitioner?.data_source === "PRACTITIONER_ACCOUNT_VIEW_NM") {
        return "Not in Netsuite: Imported from Badger";
    }
    if (practitioner?.data_source === "SALES ASSISTANT") {
        if (!practitioner?.stage || practitioner?.stage === "LEAD") {
            if (practitioner.status === "LEAD-INCOMPLETE") {
                return "Not in Netsuite: Incomplete Lead"
            }
            if (practitioner.status === "LEAD-READY2SUBMIT") {
                return "Not in Netsuite: Ready to Submit"
            }
            if (practitioner.status === "LEAD-AWAITING-NETSUITE") {
                return "Submitted to Netsuite: Awaiting Qualification Process."
            }
            if (practitioner.status === "New" || practitioner.status === "No Response" || practitioner.status === "Unqualified" || practitioner.status === "Sales Rep" || practitioner.status === "Established" || practitioner.status === "Lost (L)") {
                return ""
            }
        }
        if (practitioner?.netsuite_id) {
            return "";
        }
        if (practitioner?.stage === "PROSPECT" || practitioner?.stage === "CUSTOMER") {
            return "";
        }

        return "Not in Netsuite: Unknown status";
    }

    return "Not in Netsuite: Missing Data Source Value";
}

export const presetKeywordsForLeadSearch = [
    { value: "acupuncture", label: "Acupuncture" },
    { value: "allergies", label: "Allergies" },
    { value: "allergy", label: "Allergy" },
    { value: "alternative medicine", label: "Alternative Medicine" },
    { value: "amin", label: "Amin" },
    { value: "arthritis", label: "Arthritis" },
    { value: "cardiologist", label: "Cardiologist" },
    { value: "cardiology", label: "Cardiology" },
    { value: "cardiovascular", label: "Cardiovascular" },
    { value: "chiropractic", label: "Chiropractic" },
    { value: "chiropractor", label: "Chiropractor" },
    { value: "chiropractors", label: "Chiropractors" },
    { value: "clinical", label: "Clinical" },
    { value: "cnc", label: "CNC" },
    { value: "coach", label: "Coach" },
    { value: "compounding pharmacy", label: "Compounding Pharmacy" },
    { value: "cranial sacral", label: "Cranial Sacral" },
    { value: "d.o.", label: "D.O." },
    { value: "dc", label: "DC" },
    { value: "dds", label: "DDS" },
    { value: "dentist", label: "Dentist" },
    { value: "dermatologist", label: "Dermatologist" },
    { value: "dietician", label: "Dietician" },
    { value: "dnm", label: "DNM" },
    { value: "dnp", label: "DNP" },
    { value: "do", label: "DO" },
    { value: "doctor", label: "Doctor" },
    { value: "doctors", label: "Doctors" },
    { value: "dpt", label: "DPT" },
    { value: "emg", label: "EMG" },
    { value: "family medicine", label: "Family Medicine" },
    { value: "fnp", label: "FNP" },
    { value: "functional medicine", label: "Functional Medicine" },
    { value: "gynecologist", label: "Gynecologist" },
    { value: "gynecology", label: "Gynecology" },
    { value: "healing", label: "Healing" },
    { value: "health", label: "Health" },
    { value: "health coach", label: "Health Coach" },
    { value: "health store", label: "Health Store" },
    { value: "holistic", label: "Holistic" },
    { value: "homeopathic", label: "Homeopathic" },
    { value: "homeopathy", label: "Homeopathy" },
    { value: "hrt", label: "HRT" },
    { value: "integrated", label: "Integrated" },
    { value: "integrative", label: "Integrative" },
    { value: "internal medicine", label: "Internal Medicine" },
    { value: "l.ac", label: "L.Ac" },
    { value: "lac", label: "Lac" },
    { value: "m.d.", label: "M.D." },
    { value: "md", label: "MD" },
    { value: "mdvip", label: "MDVIP" },
    { value: "med spa", label: "Med Spa" },
    { value: "medical spa", label: "Medical Spa" },
    { value: "mph", label: "MPH" },
    { value: "natural medicine", label: "Natural Medicine" },
    { value: "naturopath", label: "Naturopath" },
    { value: "naturopathic", label: "Naturopathic" },
    { value: "nd", label: "ND" },
    { value: "neuro", label: "Neuro" },
    { value: "nmd", label: "NMD" },
    { value: "nourishing", label: "Nourishing" },
    { value: "nutrition", label: "Nutrition" },
    { value: "nutritionist", label: "Nutritionist" },
    { value: "ob/gyn", label: "OB/GYN" },
    { value: "orthopedic", label: "Orthopedic" },
    { value: "pa", label: "PA" },
    { value: "pa-c", label: "PA-C" },
    { value: "pain management", label: "Pain Management" },
    { value: "pediatrician", label: "Pediatrician" },
    { value: "pediatrics", label: "Pediatrics" },
    { value: "pharmacist", label: "Pharmacist" },
    { value: "pharmacy", label: "Pharmacy" },
    { value: "phd", label: "PhD" },
    { value: "physicians", label: "Physicians" },
    { value: "plastic surgery", label: "Plastic Surgery" },
    { value: "post", label: "Post" },
    { value: "preventative medicine", label: "Preventative Medicine" },
    { value: "pt", label: "PT" },
    { value: "rd", label: "RD" },
    { value: "rdn", label: "RDN" },
    { value: "registered dietitian", label: "Registered Dietitian" },
    { value: "rn", label: "RN" },
    { value: "supplements", label: "Supplements" },
    { value: "surgeon", label: "Surgeon" },
    { value: "urgent care", label: "Urgent Care" },
    { value: "weight loss", label: "Weight Loss" },
    { value: "weightloss", label: "Weightloss" },
    { value: "wellness", label: "Wellness" },
];